import { AbstractDTO } from '@signature-it/ngx-generic/models';
import { ContextComponents } from '@signature-it/ngx-catalogue/enums';

export class ProductTabContextDTO extends AbstractDTO {

    context_id: number;
    field_layout: string;
    order: number;
    name: string;
    solr: any;
    key: string;
    solr_field: string;
    image_extension: string;
    index_field: string;
    table_title: string;

    constructor(attributes: object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.context_id = attributes['context_id'];
        this.field_layout = attributes['field_layout'] || ContextComponents.PARAGRAPH;
        this.order = attributes['order'] ? parseInt(attributes['order'], 10) : 100;
        this.name = attributes['name'] || '';
        this.solr = attributes['solr'] || undefined;
        this.solr_field = attributes['solr_field'] || '';
        this.image_extension = attributes['image_extension'] || '';
        this.index_field = attributes['index_field'] || '';
        this.table_title = attributes['table_title'] || '';
        this.key = `${this.name}___${this.field_layout}`;

    }

    setSolr(data) {
        this.solr = data;
    }
}
